$(function () {

    var previousMessage = "";
    var recognition = null;
    var recognitionStart = false;
    var voiceRecognitionTimeout;
    var translations = {};
    var tooltipsterInstance;

    init();

    function init() {
        appendBotToolbar();
        initTranslations();
        initRecognition();
        initEvents();
        doBotInitialAnimation();
    }

    /**
     * Append bot toolbar on body
     */
    function appendBotToolbar() {
        var botToolbar = '<div class="bot-toolbar">' +
            '                   <div class="bot-container"></div>' +
            '                   <div class="main-chat-container">' +
            '                       <div id="users-button-bar">' +
            '                           <div id="user-button-0" class="user-button">' +
            '                               <span class="user-avatar bot"></span>' +
            '                           </div>' +
            '                       </div>' +
            '                   </div>' +
            '              </div>';

        var $mainLayoutContainer = $('.mainLayoutContainer');
        var $container = $mainLayoutContainer.length ? $mainLayoutContainer : $("body");

        $container.append(botToolbar);
    }

    function initTranslations() {
        translations = ChatBotUtils.initBotTranslations();
    }

    function initRecognition() {
        // voice to text Web API
        var RecognitionLib = window.webkitSpeechRecognition || window.SpeechRecognition;
        if (RecognitionLib) {
            recognition = new RecognitionLib();
        }
    }

    /**
     * Create dialog and append it to body
     */
    function createBotDialog() {
        $("body").append("<div id='Dialog0'>" +
            "               <div class='direct-chat direct-chat-info'>" +
            "                   <div class='box-body'>" +
            "                       <div class='direct-chat-messages'></div>" +
            "                   </div>" +
            "                   <div class='iswriting'></div>" +
            "                   <div class='scrollBottom no-display'> " +
            "                       <span class='scrollBottomIcon'></span>" +
            "                   </div>" +
            "                   <div id='voice-to-text'>" +
            "                       <input type='text' class='textarea-msg' name='message' placeholder='" + translations.labelInputPlaceholderBot + "' autocomplete='off'>" +
            "                       <div class='input-icons-container'>" +
            generateIconsMarkup() +
            "                       </div>" +
            generateListeningMarkup() +
            "                    </div>" +
            "               </div>" +
            "           </div>");
    }

    /**
     * Generates icons for microphone and send action
     * @returns {string}
     */
    function generateIconsMarkup() {
        var icons = "<div class='send-icon'></div>";

        if (recognition) {
            icons = "   <div class='microphone-icon'></div>" +
                "       <div class='send-icon no-display'></div>";
        }
        return icons;
    }

    /**
     * Generates listening text and animated dots
     * @returns {string}
     */
    function generateListeningMarkup() {
        var result = "  <div class='listening'>" +
            "               <div class='text'>" + translations.labelListening + "</div>" +
            "               <div id='loader'>" +
            "                   <div class='dotsContainer'>" +
            "                       <span class='dot'></span>" +
            "                       <span class='dot'></span>" +
            "                       <span class='dot'></span>" +
            "                   </div>" +
            "               </div>" +
            "           </div>";

        return result;
    }

    /**
     * Set configuration for bot dialog
     */
    function setBotDialog() {

        $("#Dialog0").dialog({
            draggable: false,
            autoOpen: false,
            closeOnEscape: true,
            resizable: false,
            title: translations.labelBotTitle,
            modal: false,
            minHeight: 200,
            maxHeight: 532,
            height: "auto",
            width: 400,
            responsive: false,
            position: {
                my: "right bottom",
                at: getDialogPosition(),
                of: "#user-button-0",
                collision: "flip, none"
            },
            classes: {
                "ui-dialog": "user-dialog0"
            },

            open: openDialogHandler,

            show: {
                effect: "none"
            },
            hide: {
                effect: "none"
            }
        });
    }

    /**
     * Get right position of dialog different when bot is on login page or inside application
     * @returns {string}
     */
    function getDialogPosition() {
        var position = "right-5 top-25";

        if (typeof jsModelUI !== "undefined") {
            position = "right-220 top-25";
        }

        return position;
    }

    function openDialogHandler() {
        var $dialog = $(this);
        var $dialogParent = $dialog.parent();

        //Save the top of dialog
        if ($dialog.data("init") !== 1) {
            //Change flag at init option
            $dialog.data("init", 1);

            //Toolbar buttons
            $dialogParent.find(".ui-dialog-titlebar").append("<span class='toolbar-window'><span class='minimize-window'></span></span>");

            //Set hide 'is writing...'
            toggleIsWritingIndicator();
            $dialogParent.find(".ui-dialog-titlebar-close").first().addClass("no-display");

            initScrollBottomEvent($dialogParent);

            //Minimize button event
            $dialogParent.find(".minimize-window").click(function () {
                $dialog.dialog("close");
                $('#user-button-0').toggleClass('open');
            });

            // because on the login page we don't have jsModelUI, we can use it to prevent loading history on login page
            if (typeof jsModelUI !== 'undefined') {
                loadHistory();
            }

            //textarea event
            $dialog.find("input.textarea-msg").keyup(function (e) {

                toggleInputIcons();

                //fill the input with the previous message when the user press arrow up key
                if (e.which === 38 && previousMessage) {
                    $(this).val(previousMessage);
                }

                //send the message by pressing ENTER
                if ((e.which === 13) && !e.shiftKey) {
                    sendMessage();
                }
                return false;
            });
        }

        //Go to bottom
        initSlimScroll($dialogParent.find(".direct-chat-messages"), 'bottom');
    }

    function initScrollBottomEvent($dialogParent) {
        // Set hide 'go down' button
        var $messagesArea = $dialogParent.find(".direct-chat-messages");
        var $scrollBottomBtn = $dialogParent.find(".scrollBottom").first();
        $messagesArea.on("scroll", function () {
            // scrollOffset is the distance from where to show the scrollBottom button
            // window height is 450px
            var scrollOffset = 600;
            var scrollHeight = $messagesArea[0] ? $messagesArea[0].scrollHeight : $messagesArea.context.documentElement.scrollHeight;
            var scrollPointToShowGoDownButton = scrollHeight - scrollOffset;
            var scrollTop = $messagesArea[0] ? $messagesArea[0].scrollTop : $messagesArea.context.documentElement.scrollTop;
            if (scrollPointToShowGoDownButton < scrollTop) {
                $scrollBottomBtn.addClass("no-display");
            } else {
                $scrollBottomBtn.removeClass("no-display");
            }
        });
    }

    function sendMessage() {
        var $dialog = $("#Dialog0");
        var input = $("input.textarea-msg");
        var message = cleanMsg(input.val());
        previousMessage = message;
        input.val("");

        if (voiceRecognitionTimeout) {
            clearTimeout(voiceRecognitionTimeout);
        }

        if (message !== "") {
            var timestamp = formatDateTime();
            var data = {
                message: message
            };

            appendMessage(data, $dialog, timestamp, "me");

            toggleIsWritingIndicator();

            chatBotRequest(message, "text");

            toggleInputIcons();
        }
    }

    function toggleInputIcons() {
        var input = $("input.textarea-msg");
        var micIcon = $(".microphone-icon");
        var sendIcon = $(".send-icon");

        if (micIcon.length) {
            if (input.val() !== '') {
                micIcon.addClass('no-display');
                sendIcon.removeClass('no-display');
            } else {
                sendIcon.addClass('no-display');
                micIcon.removeClass('no-display');
            }
        }
    }

    /**
     * Init slim scroll plugin
     * @param $messagesArea
     * @param scrollPoint possible values can be "bottom", "top" or numeric value
     */
    function initSlimScroll($messagesArea, scrollPoint) {
        if (scrollPoint === "bottom") {
            scrollPoint = $messagesArea[0] ? $messagesArea[0].scrollHeight : $messagesArea.context.documentElement.scrollHeight
        } else if (scrollPoint === "top") {
            scrollPoint = 0;
        }
        $messagesArea.slimScroll({
            size: '5px',
            scrollTo: scrollPoint,
            height: 'auto',
            start: 'bottom'
        });
    }

    /**
     * Clear message from html tags, tabs and new line
     * @param text
     * @returns {*}
     */
    function cleanMsg(text) {
        //Clean html tags
        var msgHtml = text.replace(/(<([^>]+)>)/ig, "");
        //Clean html tabs and new line
        return msgHtml.replace(/(\n|\r|\r\n)$/, '');
    }

    /**
     * Append message send/received to/from server on dialog
     * @param data
     * @param $dialog
     * @param timestamp
     * @param participant could be "me" or "he"
     * @param querySessionToken
     */
    function appendMessage(data, $dialog, timestamp, participant, querySessionToken) {
        var box = $dialog.parent().find(".box-body");
        var $messagesLastElement = box.find('.direct-chat-messages').last();
        var $messagesArea = $dialog.parent().find(".direct-chat-messages");
        var messagePosition = participant === "me" ? "right" : "left";

        var message = ChatBotUtils.generateMessageMarkup(data, timestamp, messagePosition, participant, querySessionToken);
        $messagesLastElement.append(message);

        initOwlCarousel();
        initTooltipsterOnlineUsers();

        var $truncateText = $(".truncateText ");
        if ($truncateText.length){
            EllipsisText.truncate($truncateText, {
                width: 85,
                parseHTML: true
            });
        }

        if (data.menu) {
            appendMenu(data, $dialog);
        }

        initSlimScroll($messagesArea, 'bottom');
    }

    function prependHistoryMessage(data, $dialog, querySessionToken) {
        var box = $dialog.parent().find(".box-body");
        var $messagesLastElement = box.find('.direct-chat-messages').last();
        var $messagesArea = $dialog.parent().find(".direct-chat-messages");
        var results = data.results;
        var messages = "";

        for (var i = 0; i < results.length; i++) {
            var messagePosition = results[i].participant === "me" ? "right" : "left";
            var message = ChatBotUtils.generateMessageMarkup(results[i].data, results[i].timestamp, messagePosition, results[i].participant, querySessionToken);
            messages += message;
        }

        $messagesLastElement.prepend(messages);

        initOwlCarousel();
        initTooltipsterOnlineUsers();

        initSlimScroll($messagesArea, "bottom");
    }


    function initOwlCarousel() {
        var $itemsList = $('.itemsList.owl-carousel');

        // prevent owlCarousel to be initialized on the login page because is not available
        if ($itemsList.length) {
            $itemsList.owlCarousel({
                items: 1,
                autoWidth: true,
                nav: true,
                dots: false,
                navText: [],
                navClass: ['owl-prev navButton', 'owl-next navButton'],
                navElement: 'div'
            });
        }
    }

    function appendMenu(data, $dialog) {
        var box = $dialog.parent().find(".box-body");
        var $messagesLastElement = box.find('.direct-chat-messages').last();
        var menu = "";

        for (var i = 0; i < data.menu.results.length; i++) {
            menu += "   <div class='menuItem' data-action-message ='" + data.menu.results[i].type + "' data-category-name='" + data.menu.results[i].name + "'>" +
                "           <span>" + data.menu.results[i].name + "</span>" +
                "       </div>";
        }

        $messagesLastElement.append("<div class='direct-chat-msg-menu'>" + menu + "</div>");
    }

    function chatBotRequest(message, actionType) {
        $.ajax({
            type: "POST",
            dataType: 'json',
            headers: getRequestHeaders(),
            contentType: "application/json",
            url: window.chatBotUrl,
            // url: 'resources/data/WFYA.json',
            data: JSON.stringify({
                "message": message,
                "actionType": actionType
            })
        }).then(
            function (data) {
                switch (data.actionType) {
                    case 'history':
                    case 'searchWebshop':
                    case 'onlineUsers':
                        doRequestForQuerySessionToken(data);
                        break;
                    default:
                        requestCallback(data);
                }
            },
            function () {
                var message = "<span class='errorMessage'>" + translations.textErrorMessageBot + "</span>";
                var data = {
                    message: message
                };

                requestCallback(data);
            });
    }

    function doRequestForQuerySessionToken(data) {
        //create request for secure token in order to add the new token when you choose another picture
        $.ajax({
            url: jsModelUI.querySessionToken.appUrl,
            headers: getG2RequestHeaders()
        }).then(
            function (response) {
                //set the query token received from the server
                var querySessionToken = response.payload.qst;
                switch (data.actionType) {
                    case 'history':
                        historyRequestCallback(data, querySessionToken);
                        break;
                    default:
                        requestCallback(data, querySessionToken);
                }
            },
            function () {
                switch (data.actionType) {
                    case 'history':
                        historyRequestCallback(data);
                        break;
                    default:
                        requestCallback(data);
                }
            });
    }

    /**
     * Add session token based on the location of bot login/G1 or G2 (logged user)
     * @returns {Object}
     */
    function getRequestHeaders() {
        var headers = {
            "X-CSRF-TOKEN": $("#hdFormToken").val()
        };

        // case where user is inside the application
        if (typeof jsModelUI !== 'undefined') {
            headers["X-CSRF-TOKEN"] = jsModelUI.formToken ? jsModelUI.formToken : jsModelUI.page.formToken;
        }

        return headers;
    }

    function getG2RequestHeaders() {
        var headers = {};

        headers["X-CSRF-TOKEN"] = jsModelUI.formToken ? jsModelUI.formToken : jsModelUI.page.formToken;
        headers["x-apptoken"] = '8bda0c36884bd387';

        return headers;
    }

    /**
     * Append message, remove dots on callback success or error
     * @param data
     * @param querySessionToken
     */
    function requestCallback(data, querySessionToken) {
        var timestamp = formatDateTime();
        var $dialog = $("#Dialog0");

        toggleIsWritingIndicator();

        appendMessage(data, $dialog, timestamp, "he", querySessionToken);
    }

    function historyRequestCallback(data, querySessionToken) {
        var $dialog = $("#Dialog0");

        toggleIsWritingIndicator();

        prependHistoryMessage(data, $dialog, querySessionToken);
    }

    /**
     * Format date time
     * @returns {string}
     */
    function formatDateTime() {
        var format = 'MM/dd/yyyy HH:mm';

        if (typeof jsModelUI !== "undefined") {
            format = jsModelUI.userDetails.clientClock.dateFormat + ' HH:mm';
        }

        return moment.parseZone(Date.now()).formatWithJDF(format);
    }

    /**
     * Initialize events used to interact with bot
     */
    function initEvents() {
        $(document).on("click", ".user-avatar", botIconClickHandler);

        $(document).on("click", ".microphone-icon", microphoneIconClickHandler);

        $(document).on("click", ".send-icon", sendMessage);

        $(document).on("click", ".itemCategory", itemCategoryClickHandler);

        $(document).on("click", ".menuItem", menuItemClickHandler);

        $(document).on("click", ".actionLink", openLinkHandler);

        $(document).on("click", ".userItemContainer", openUserDetails);

        $(document).on("click", ".scrollBottom", scrollToBottom);

        $(window).on('resize', repositionDialog);
    }

    /**
     * Open or initialize bot dialog
     */
    function botIconClickHandler() {
        // create dialog element does not exist
        if (!$("#Dialog0").length) {
            createBotDialog();
            setBotDialog();
        }

        $('#user-button-0').toggleClass('open');

        toggleBotDialog();
    }

    /**
     * Start voice recognition when clicking the microphone icon
     */
    function microphoneIconClickHandler() {
        // recognitionStart is used to prevent browser error on double clicking
        if (!recognitionStart) {
            recognitionStart = true;
            recognition.start();
            // clear any entered text
            var input = $("input.textarea-msg");
            input.val("");

            // activate microphone indicators
            var microphoneIcon = $(".microphone-icon");
            microphoneIcon.removeClass("disabled");

            var inputIconsContainer = $(".input-icons-container");
            inputIconsContainer.addClass('micShadowPulse');

            var voiceToText = $("#voice-to-text");
            voiceToText.addClass("microphoneActive");

            recognition.onresult = function (event) {
                var speechToText = event.results[0][0].transcript;

                input.val(input.val() + speechToText);

                voiceRecognitionTimeout = setTimeout(function () {
                    var keyUpEvent = $.Event('keyup');
                    keyUpEvent.which = 13;
                    keyUpEvent.keyCode = 13;
                    input.focus();
                    input.trigger(keyUpEvent);
                }, 1000);
            };

            recognition.onaudioend = function () {
                recognitionStart = false;
                inputIconsContainer.removeClass('micShadowPulse');
                voiceToText.removeClass("microphoneActive");
            };

            recognition.onerror = function () {
                recognition.stop();
                recognitionStart = false;
                inputIconsContainer.removeClass('micShadowPulse');
                voiceToText.removeClass("microphoneActive");
                microphoneIcon.addClass("disabled");

                navigator.mediaDevices.getUserMedia({audio: true})
                    .then(function (stream) {
                        initTooltipster(input, true);
                    })
                    .catch(function (err) {
                        console.log('No microphone is available!');
                        initTooltipster(input, false);
                    });

            }
        }
    }

    /**
     * Action when using the "search for" functionality from SSP
     */
    function itemCategoryClickHandler() {
        var $this = $(this);

        var name = $this.data("categoryName");
        var message = "<div>" + translations.textSelectedCategory + " <span class='category'>" + name + "</span></div>";

        sendMessageFromInteractiveInterface($this, message);
    }

    function menuItemClickHandler() {
        var $this = $(this);

        var name = $this.data("categoryName");
        var message = "<div>" + name + "</div>";

        var menu = $this.parent();
        menu.remove();

        sendMessageFromInteractiveInterface($this, message);
    }

    function openLinkHandler() {
        var $this = $(this);
        var url = $this[0].href;

        if ($this.hasClass("proxyUserRequire")){
            var msg = $this.data("proxyUserMsg");
            var urlForProxyUser = $this.data("urlForProxyUser");
            doProxyUserLogin(msg, urlForProxyUser, url);
        } else {
            compareLinkWhitCurrentLink(url)
        }

        // prevent double link navigation on click
        return false;
    }

    function openUserDetails() {
        var $this = $(this);
        var url = $this.data("link");

        compareLinkWhitCurrentLink(url);
    }

    function scrollToBottom() {
        var $dialog = $("#Dialog0");
        var $messagesArea = $dialog.parent().find(".direct-chat-messages");

        initSlimScroll($messagesArea, "bottom");
    }

    /**
     * Reposition dialog when  window is resized
     */
    function repositionDialog() {
        var userDialog = $("#Dialog0");
        if (userDialog.dialog("isOpen") === true) {
            userDialog.dialog("option", "position", {
                my: "right bottom",
                at: getDialogPosition(),
                of: "#user-button-0"
            });
        }
    }

    function doProxyUserLogin(msg, urlForProxyUser, url) {
        var content = '<p>' + msg + '</p>';
        window.top.LookupDialog.openDialog($(content), window, {
            width: 450,
            height: 140,
            classes: {
                "ui-dialog-titlebar": "no-display"
            },
            buttons: [
                {
                    text: translations.buttonYes,
                    class: "confirm",
                    click: function () {
                        window.top.LookupDialog.closeDialog(window);

                        // window.open(urlForProxyUser, "_self");
                        $.ajax({
                            type: 'GET',
                            url: urlForProxyUser,
                            success: function (response, opts) {
                                compareLinkWhitCurrentLink(url)
                            },
                            error: function (response, opts) {
                                console.log("Error when login", response)
                            }
                        })
                    }
                },
                {
                    text: translations.buttonNo,
                    click: function () {
                        window.top.LookupDialog.closeDialog(window);
                    }
                }

            ]
        });
    }

    function compareLinkWhitCurrentLink(url) {
        if (window.location.href  === url) {
            window.location.reload(true);
        } else {
            window.open(url, "_self");
        }
    }

    function loadHistory() {
        toggleIsWritingIndicator();
        chatBotRequest("history", "loadHistory");
    }

    function sendMessageFromInteractiveInterface($clickedElement, message) {
        var actionMessage = $clickedElement.data("actionMessage");

        var timestamp = formatDateTime();
        var $dialog = $("#Dialog0");
        var data = {
            message: message
        };

        appendMessage(data, $dialog, timestamp, 'me');

        toggleIsWritingIndicator();

        chatBotRequest(actionMessage, "text");
    }

    /**
     * Configure tooltipster
     * @param $element
     */
    function initTooltipster($element, hasMicrophone) {
        var tooltipMessage = translations.msgRequestFailed;

        if (!hasMicrophone) {
            tooltipMessage = translations.labelNoMicrophone;
        }

        if (!tooltipsterInstance) {
            var tooltipsterOptions = {
                trigger: 'custom',
                triggerClose: {
                    click: true
                },
                content: tooltipMessage,
                side: ['bottom', 'top'],
                distance: 5,
                maxWidth: 250,
                animationDuration: [0, 0],
                arrow: false,
                functionPosition: function (instance, helper, position) {
                    position.coord.left = helper.geo.origin.windowOffset.left + 50;
                    return position;
                }
            };

            tooltipsterInstance = $element.tooltipster(tooltipsterOptions);
        } else {
            // tooltip instance already created, just update it
            tooltipsterInstance.tooltipster('content', tooltipMessage);
        }

        tooltipsterInstance.tooltipster('open');

        $element.click(
            function () {
                tooltipsterInstance.tooltipster('close');
                $element.off('click');
            }
        );
    }

    function initTooltipsterOnlineUsers() {
        // take only elements that don't have tooltip
        var $onlineUsers = $('.direct-chat-msg-onlineUsersList').find('.userItemContainer:not(".tooltipstered")');

        if ($onlineUsers.length){
            $onlineUsers.tooltipster({
                functionInit: function (instance, helper) {
                    var content = instance.content();
                    var data = JSON.parse(content);
                    var newContent = '';

                    for (var i = 0; i < data.length; i++) {
                        if (data[i].value) {
                            newContent += ' <div class="tooltipsterItem">' +
                                '               <span class="label">' + data[i].label + ' :</span>' +
                                '               <span class="value">' + data[i].value + '</span>' +
                                '           </div>'
                        }
                    }

                    instance.content(newContent);
                },
                contentAsHTML: true,
                arrow: false
            });
        }
    }

    /**
     * Toggle bot dialog on click
     */
    function toggleBotDialog() {
        var userDialog = $("#Dialog0");

        if (userDialog.dialog("isOpen") === false) {
            //Close all dialogs
            $("[id^='Dialog']").dialog("close");

            $('.user-button').removeClass('open');

            $('#user-button-0').toggleClass('open');

            userDialog.dialog("open");
        } else {
            userDialog.dialog("close");
        }
    }

    /**
     * Show visual feedback that the user request is being processed
     */
    function toggleIsWritingIndicator() {
        var $dialog = $("#Dialog0");
        $dialog.parent().find(".iswriting").first().toggleClass("no-display");
    }

    /**
     * Make the bot pop!
     */
    function doBotInitialAnimation() {
        $('#user-button-0').effect('bounce', {distance: 15}, 2000);
    }
});
